module.exports = __webpack_public_path__ + "files/Participant_list_example.6d09d91e.xlsx";